import { VCol } from 'vuetify/lib/components/VGrid';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "data-cy": "widget-size-select"
    }
  }, [_c(VLabel, [_vm._v(_vm._s(_vm.$t('Dashboards.components.widgetSizeSelect.label')))]), _c(VRow, _vm._l(_vm.WIDGET_SIZE_OPTIONS, function (size) {
    return _c(VCol, {
      key: size.value
    }, [_c('core-button', {
      attrs: {
        "color": _vm.color,
        "active": _vm.value === size.value,
        "block": "",
        "value": size.value,
        "data-cy": `widget-size-select-${size.value}`
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('input', size.value);
        }
      }
    }, [_vm._v("\n        " + _vm._s(size.text) + "\n      ")])], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };